<template>
  <div style="padding-top: 5px">
  <svg width="100%" :height="height+10" :x="x" :y="y" ref="svg">
    <g v-for="(row, index) in data" :key=index :transform="`translate(0 ${index*barHeight*1.33})`">
      <text
        x="0" 
        :y="barHeight/2+4"
        text-anchor="left"
        font-size="12"
        style="font-size: 12px"
        fill="#111"
        class="grid-label">
        {{row[0]}}
      </text>
      <rect
        :x="labelWidth"
        y="0"
        :height="barHeight"
        :width="getX(row[1])" 
        :fill="colors ? colors[index] : 'red'" />
      <text 
        :x="getX(row[1])+labelWidth+3" 
        :y="barHeight/2+4"
        text-anchor="left"
        font-size="12"
        style="font-size: 12px"
        fill="#111"
        class="grid-label">
        {{format(row[1])}}
      </text>
    </g>
    <!-- <text v-for="(row, index) in data"
      :key="'name'+index"
      :x="0" 
      :y="index*18+11"
      text-anchor="left"
      :font-size="12"
      fill="#111"
      class="grid-label">
      {{row[0]}}
    </text>
    <rect v-for="(row, index) in data"
      :key="'bar'+index"
      :x="labelWidth"
      :y="index*18"
      :height="14"
      :width="getX(row[1])" 
      fill="#6496B1" />
    <text v-for="(row, index) in data"
      :key="'label'+index"
      :x="getX(row.value)+labelWidth+3" 
      :y="index*18+11"
      text-anchor="left"
      :font-size="12"
      fill="#111"
      class="grid-label">
      {{format(row[1])}}
    </text> -->
  </svg>
  </div>
  <!-- <div class="chart-wrap">
    <div class="grid horizontal">
      <div v-for="item in data" :key="item.label" class="bar" :style="'--bar-value:'+item.value+'%; background-color:'+item.color+';'" :data-name="item.label" title="Your Blog 85%"></div>
    </div>
  </div> -->
  <!-- <table class="tableBarChart">
    <tr>
      <td>SPD</td>
      <td class="barContainer">
        <div class="bar" style="width:55%; background-color: red">
          <span>55%</span>
        </div>
      </td>
    </tr>
    <tr>
      <td>AfD</td>
      <td><div class="bar" style="width:5%; background-color: blue"></div></td>
      <td>5%</td>
    </tr>
  </table> -->
</template>

<script>
import {scaleLinear} from 'd3' //scaleTime, , format

export default {
  name: 'BarChart',
  props: {
    data: Array,
    colors: { type: Array, default: () => ["#577bb7","#d13d3d","#6FA746","#ed7d38","#a284c7","#edbf57","#c1c1c1","#88a3d6","#f36969","#a5ce81","#ffa46e","#c0a4e2","#ffd882","#d5d5d5",] },
    barHeight: { type: Number, default: 16 },
    height: { type: Number, default: 100 },
    width: { type: String, default: '100%' },
    x: { type: Number, default: 0 },
    y: { type: Number, default: 0 },
    xRange: Array,
    suffix: String,
    fontSize: { type: Number, default: 13 },
    barMargin: { type: Number, default: 5 },
    plusminus: { type: Boolean, default: false },
    baseline: { type: Boolean, default: false },
    elipsis: { type: Boolean, default: true },
  },
  data () {
    return {
      computedWidth: 600,
      labelWidth: 55,
      // barMargin: 5,
    }
  },
  methods: {
    fitProjection () {
      // if (this.width != '100%') {
      //   this.computedWidth = this.width
      // } else {
        this.computedWidth = this.$refs.svg.getBoundingClientRect().width
      // }
    },
    format (number) {
      let prefix = ''
      
      if(this.plusminus) {
        if (number==0) {
          prefix = '±'
        } else if (number > 0) {
          prefix = '+'
        } else {
          prefix = ''
        }
      }
      
      return prefix + String(number).replace('.',',') + (this.suffix||'')
    },
    formatDate (str) {
      const date = new Date(str)
      return date.toLocaleDateString()
    },
    capLength (str) {
      let maxLength = parseInt(this.barThickness/10)
      if (str.length>maxLength&&this.elipsis) {
        return str.slice(0,maxLength) + '...'
      } else {
        return str
      }
    },
    getX (val) {
      let x = scaleLinear()
        .domain(this.xRangeComputed)
        .range([0, this.computedWidth - this.labelWidth - 30])
      return x(val)
    },
    // getX (index) {
    //   return index*this.barThickness + index*this.barMargin
    // }
  },
  computed: {
    xRangeComputed: function () {
      if (this.xRange) {
        return this.xRange
      } else {
        let max = Math.max.apply(Math, this.data.map( el => el[1] ))
        return [0, max]
      }
    },
    barThickness: function () {
      let n = this.data.cols.length
      // return n
      return (this.computedWidth - this.barMargin*(n-1))/n
    }
  },
  mounted () {
    this.fitProjection()
    // window.addEventListener('resize', debounce(this.fitProjection, 250))
    // setTimeout(() => { this.fitProjection() }, 2000)
  },
  updated () {
    this.fitProjection()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

$width:20px;
$height:200px;
$bar-size:45px;
$bar-color:#F16335;
$bar-rounded: 3px;

$grid-color:#aaa;

.chart-wrap{
  width: $width;
  height: $height;
  font-family:sans-serif;
  
  .title {
    text-align:center; 
  }
}

.grid{
  width:100%;
  height:100%;
  display:flex;
  flex-direction:row;
  justify-content:center;
  border-bottom:2px solid $grid-color;
  background:repeating-linear-gradient(0deg,transparent,transparent 19.5%,fadeout($grid-color,30%) 20%);
  
  .bar {
    background-color:$bar-color;
    width:$bar-size;
    height: var(--bar-value);
    align-self:flex-end;
    margin:0 auto;
    border-radius:$bar-rounded $bar-rounded 0 0;
    position:relative;
    
    &.bar:hover{
      opacity:0.7;
    }
    
    &::after{
      content:attr(data-name);
      top:-3em;
      padding:10px;
      display:inline-block;
      white-space:nowrap;
      position:absolute;
      transform:rotate(-45deg);
    }
  }
  
  &.horizontal{
    flex-direction:column;
    border-bottom:none;
    border-left:2px solid $grid-color;
    background:repeating-linear-gradient(90deg,transparent,transparent 19.5%,fadeout($grid-color,30%) 20%);
    .bar{
      height:$bar-size;
      width: var(--bar-value);
      align-self:flex-start;
      margin:auto 0 auto 0;
      border-radius:0 $bar-rounded $bar-rounded 0;
      
      &::after{
        top:initial;
        left:100%;
        padding:0 10px;
        display:inline-block;
        white-space:nowrap;
        position:absolute;
        transform:rotate(0deg);
        line-height:$bar-size;
      }      
    }
  }
}

.tableBarChart {
  tr {
    td.barContainer {
      width: 100px;

      .bar {
        height: 10px;
        position: relative;

        span {
          position: absolute;
          top: 0;
          right: 5px;
        }
      }
    }
  }
}
</style>